var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowSmallLeft = function SvgArrowSmallLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8954 17.2857C11.8335 15.5963 10.7143 14.5094 9.1944 12.681C8.9352 12.3692 8.9352 11.9165 9.1944 11.6047C10.7143 9.7763 11.8335 8.68938 13.8955 7",
    stroke: "#474752",
    strokeWidth: 1.71429,
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgArrowSmallLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjg5NTQgMTcuMjg1N0MxMS44MzM1IDE1LjU5NjMgMTAuNzE0MyAxNC41MDk0IDkuMTk0NCAxMi42ODFDOC45MzUyIDEyLjM2OTIgOC45MzUyIDExLjkxNjUgOS4xOTQ0IDExLjYwNDdDMTAuNzE0MyA5Ljc3NjMgMTEuODMzNSA4LjY4OTM4IDEzLjg5NTUgNyIgc3Ryb2tlPSIjNDc0NzUyIiBzdHJva2Utd2lkdGg9IjEuNzE0MjkiIHZlY3Rvci1lZmZlY3Q9Im5vbi1zY2FsaW5nLXN0cm9rZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";